'use strict';

module.exports = /* @ngInject */ ["$q", "$log", "$window", "authApiFactory", "authService", "authTokenProvider", function ($q, $log, $window, authApiFactory, authService, authTokenProvider) {
  var headerValues = {
    'Content-type': 'application/x-www-form-urlencoded',
    Authorization: 'Basic UkVESVRlY2g6UjNkIVQzY2g='
  };

  function postAuthByEikonSessionToken() {
    var eikonTokenParams = {
      "grant_type": "eikon_session_token"
    };
    return postAuthByParams(eikonTokenParams);
  }

  function postAuthByPasswordServerToken(token, username, timestamp) {
    var passwordServerTokenParams = {
      "grant_type": "password_server_token",
      "token": token,
      "username": username,
      "timestamp": timestamp
    };
    return postAuthByParams(passwordServerTokenParams);
  }

  function postAuthByUsername(username, password) {
    var usernameAuthParams = {
      "username": username,
      "password": password,
      "grant_type": "password"
    };
    return postAuthByParams(usernameAuthParams)
      .catch(function(response){
        if(response.data.rtUserMfaPrompt){
          $log.info('Prompting user for Multi Factor Authentication');
          return response.data;
        }
        $log.info("Unable to authorize user");
        return $q.reject();
      });
  }

  function postAuthByUsernameAndRtDevice(username, password, rtDevice) {
    var authParams = {
      "username": username,
      "password": password,
      "rtDevice": rtDevice,
      "grant_type": "password_and_device"
    }
    return postAuthByParams(authParams)
      .catch(function(response){
        if(response.data.rtUserMfaPrompt){
          $log.info('Prompting user for Multi Factor Authentication');
          return response.data;
        }
        $log.info("Unable to authorize user");
        return $q.reject();
      });
  }

  function postAuthByRefreshToken(refreshToken) {
    var refreshTokenParams = {
      "refresh_token": refreshToken,
      "grant_type": "refresh_token"
    };
    return postAuthByParams(refreshTokenParams);
  }

  function encodeQueryData(params) {
    var authParams = [];
    for (var key in params) {
      authParams.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
    }
    return authParams.join('&');
  }

  function postAuthByParams(authFormData) {
    return authApiFactory.create().then(function (authApi) {
      return authApi.all('token')
              .withHttpConfig({ignoreAuthModule: true, transformRequest: angular.identity})
              .customPOST(encodeQueryData(authFormData), '', '',
                  headerValues
              );
    });
  }

  function storeAuthTokenFrom(data) {
    $window.localStorage.setItem('authorizationToken', JSON.stringify({
      access_token: data.access_token,
      refresh_token: data.refresh_token,
      token_type: data.token_type,
      expires_in: data.expires_in
    }));
  }

  function getImpersonator() {
    return getUserInfoFromAccessToken(authTokenProvider.get().access_token)
      .then(function (data) {
        return data.impersonator;
      });
  }

  function refreshTokens() {
    var refreshToken = authTokenProvider.get().refresh_token;
    postAuthByRefreshToken(refreshToken).then(function (data) {
      $log.info('Refresh successful, storing new token');
      storeAuthTokenFrom(data);
      authService.loginConfirmed();
    }, function (response) {
      $log.error('invalid refresh token, no action taken ' + JSON.stringify(response));
      authService.loginCancelled();
    });
  }

  function getUserInfoFromAccessToken(accessToken) {
    return authApiFactory.create().then(function (authApi) {
      return authApi.one('tokeninfo').withHttpConfig({ignoreAuthModule: true})
          .get(null,
               {
                 Authorization: 'Bearer: ' + accessToken
               }
          );
    });
  }

  return {
    postAuthByPasswordServerToken: postAuthByPasswordServerToken,
    postAuthByUsername: postAuthByUsername,
    postAuthByUsernameAndRtDevice: postAuthByUsernameAndRtDevice,
    postAuthByRefreshToken: postAuthByRefreshToken,
    postAuthByEikonSessionToken: postAuthByEikonSessionToken,
    storeAuthTokenFrom: storeAuthTokenFrom,
    refreshTokens: refreshTokens,
    getImpersonator: getImpersonator,
    getUserInfoFromAccessToken: getUserInfoFromAccessToken
  };
}];



//////////////////
// WEBPACK FOOTER
// /app/~/redi-idp-web-lib/dist/business/rediTokenService.js
// module id = 122
// module chunks = 0